import { useEffect, useState } from "react";
import { Button } from "../../../component/form";
import useSnackbar from "../../../hooks/useSnackbar";
import { Subscription } from "../../../services/subscription";
import { useMutation, useQuery } from "@tanstack/react-query";
import useUser from "../../../hooks/useUser";
import ActivePlanDetails from "./ActivePlanDetails";
import OtherPlanDetails from "./OtherPlanDetails";
import { Link, useLocation } from "react-router-dom";
import ButtonLoader from "../../../component/buttonLoader";
import RazorpaySubscription from "../../../component/razorpaySubscription";

const OurHealthPlan = () => {
  const token = localStorage.getItem("hollypills_token");
  const { user, isLoggedIn, logout } = useUser();
  const { snackbar } = useSnackbar();
  const [activePlanId, setActivePlanId] = useState(null);
  const [checkoutDetail, setCheckoutDetail] = useState({
    subscriptionId: ""
  });
  const [activePlanModal, setActivePlanModal] = useState(false);
  const [otherPlanModal, setOtherPlanModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const location = useLocation();

  // console.log('activePlanModal', activePlanModal)
  // ----------plain-List-Api-----------
  const { plainListApi, BuyThisPlanApi, BuyRazorPaySubscriptionApi } = Subscription();

  let payLoad = {};
  if (user?._id) {
    payLoad.payLoad = user?._id;
  }
  const { data, isLoading } = useQuery({
    queryKey: ["plainListApi"],
    queryFn: () => {
      const payLoad = {};

      if (token) payLoad.token = token;
      if (user?._id) payLoad.userId = user._id;

      return plainListApi(payLoad);
    },
  });
  const planList = data?.data?.plan_list || [];
  // console.log('planList', planList)
  // -----------------Buy-plan-mutation-----------------
  const buyPlanMutation = useMutation({
    mutationFn: (planId) => {
      setActivePlanId(planId);
      if (user.country === "India") {
        return BuyRazorPaySubscriptionApi({ planId, token });
      }

      return BuyThisPlanApi({ planId, token });
    },
    onSuccess: (data) => {
      console.log({ data });

      if (data?.data?.url) {
        window.location.href = data?.data?.url;
      } else {
        setCheckoutDetail(prev => ({
          ...prev,
          subscriptionId: data?.data?.subscriptionId
        }))
      }
    },
    onSettled: () => {
      setActivePlanId(null);
    },
    onError: (err) => {
      snackbar(err?.data?.message || "Something went wrong", "error");
    },
  });
  // ---------active-Plan-Details-----------
  const activePlanDetails = (data) => {
    setSelectedPlan(data);
    setActivePlanModal(true);
  };
  // ---------other-Plan-Details-----------
  const otherPlanDetails = (data) => {
    // setSelectedPlan(data)
    setOtherPlanModal(true);
  };

  console.log({ planList });

  return (
    <div className="container">
      <div className="wrap_plan_table">
        <div className="page_title">
          <h2>Our Health Plans</h2>
        </div>
        <div className="wrap_table">
          <table>
            <thead>
              <tr>
                <th>Plan Title</th>
                <th>Duration</th>
                <th>Consultation + Medication + Delivery</th>
                <th>Price</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {planList?.length > 0 ?
                planList?.map((plan) => {
                  const isCurrentPlanActive =
                    plan?.userSubscription?.status === "active";
                  // Check if user has any active plan
                  const userHasAnyActivePlan = planList.some(
                    (p) => p?.userSubscription?.status === "active"
                  );
                  return (
                    <tr key={plan._id}>
                      <td>{plan.planTitle}</td>
                      <td>
                        {plan.duration} Month{plan.duration > 1 ? "s" : ""}
                      </td>
                      <td>
                        {plan.consultationLimit}

                        {plan.planTitle === "Nutrition" ? "  ( Only Consultation ) " : " "}

                        {/* {plan.consultationLimit > 100 ? 'Unlimited' : plan.consultationLimit} */}
                      </td>
                      <td> {`${plan?.country === "India" ? plan?.currency : ""} ${plan.price.toFixed(2)} ${plan?.country !== "India" ? plan?.currency : ""}`}</td>
                      <td>
                        <div className="wrap_select">
                          {isLoggedIn ? (
                            isCurrentPlanActive ? (
                              // <Button
                              //   className="ActivePlan"
                              //   // onClick={() => activePlanDetails(plan)}
                              // >
                              //   Active Plan
                              // </Button>

                              <ButtonLoader
                                className="button cstm_buy_now ActivePlan"
                                isLoading={
                                  activePlanId === plan._id &&
                                  buyPlanMutation.isPending
                                }
                                onClick={() => {
                                  setSelectedPlan(plan);
                                  otherPlanDetails(plan);
                                }}
                                // onClick={() => buyPlanMutation.mutate(plan._id)}
                                text="Active"
                              >
                                Active
                              </ButtonLoader>
                            ) : userHasAnyActivePlan ? (
                              <Button
                                onClick={() => {
                                  setSelectedPlan(plan);
                                  otherPlanDetails(plan);
                                }}
                              >
                                Buy this Plan
                              </Button>
                            ) : (
                              <ButtonLoader
                                className=" button cstm_buy_now"
                                isLoading={
                                  activePlanId === plan._id &&
                                  buyPlanMutation.isPending
                                }
                                onClick={() => buyPlanMutation.mutate(plan._id)}
                                text="Buy this Plan"
                              >
                                Buy this Plan
                              </ButtonLoader>
                            )
                          ) : (
                            <Button>
                              <Link
                                className="text-blue-600 underline"
                                to="/login"
                                state={{ from: location.pathname }}
                              >
                                Buy this Plan
                              </Link>
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
                :
                null
              }
              {planList.length === 0 ?
                (
                  <tr>
                    <td colSpan={5} style={{ textAlign: "center" }}>
                      No plans available.
                    </td>
                  </tr>
                )
                :
                null
              }
            </tbody>
          </table>
        </div>
      </div>
      {/* <ActivePlanDetails
        show={activePlanModal}
        close={() => {
          setActivePlanModal(false);
          setSelectedPlan(null);
        }}
        data={selectedPlan}
      /> */}
      <OtherPlanDetails
        show={otherPlanModal}
        close={() => {
          setOtherPlanModal(false);
          setSelectedPlan(null);
        }}
        isLoading={buyPlanMutation.isPending}
        onConfirm={() => buyPlanMutation.mutate(selectedPlan._id)}
        data={selectedPlan}
      />

      {checkoutDetail.subscriptionId?.length ? <RazorpaySubscription subscriptionId={checkoutDetail.subscriptionId} /> : null}
    </div>
  );
};

export default OurHealthPlan;
